import router from 'next/router'
import React, { useEffect } from 'react'

import { Redirect } from '@components/Redirect'
import { AppRoutes } from '@constants/app-routes'
import { CustomHead } from '@ui/sections/CustomHead'

export default function BookingSolutionIsPage() {
  useEffect(() => {
    router.replace(AppRoutes.portfolioDeskBookingMobileApp)
  }, [])

  return (
    <>
      <CustomHead
        title="Multipurpose Remote Space Booking Solution"
        description="Learn how we developed a React Native app that provides space booking services for different purposes. Discover the key benefits of the app and how it offers instant access to spots for any type of activity."
        imagePath="/images/custom-head/custom-head-booking-solution.webp"
      />
      <Redirect />
    </>
  )
}
